import {Types} from './actions';
import {Types as UserManagementActionTypes} from 'pages/UserManagement/actions';
import initialState from './initialState';
import ReducerBuilder from "classes/ReducerBuilder";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.START_DELETE)
    .reduce((state, action) => {
        state.deleting = true;
        state.deleteResource = action.deleteResource;
        state.deleteResourceId = action.deleteResourceId;
        state.additionalResourceIds = action.additionalResourceIds;
        state.additionalData = action.additionalData;
        // Make an array if not sent as one
        state.postDeleteActions = Array.isArray(action.postDeleteActions) ? action.postDeleteActions : [action.postDeleteActions];
    })
    .forType(Types.SUBMIT_DELETE)
    .reduce((state, action) => {
        state.deleteChallengeSubmitted = true;
    })
    .forType(UserManagementActionTypes.SUBMIT_DELETE_USER)
    .reduce((state, action) => {
        state.deleteChallengeSubmitted = true;
    })
    .forType(UserManagementActionTypes.SUBMIT_UNDELETE_USER)
    .reduce((state, action) => {
        state.deleteChallengeSubmitted = true;
    })
    .forType(Types.DELETE_COMPLETE)
    .reduce((state, {challengeId}) => {
        state.deleteChallengeSubmitted = false;
        state.deleting = false;
        state.deleteResource = null;

        state.lastResourceIdDeleted = state.deleteResourceId;
        state.deleteResourceId = null;

        state.additionalResourceIds = null;
        state.additionalData = null;
        state.postDeleteActions = null;
    })
    .forType(Types.END_DELETE)
    .reduce((state, action) => {
        state.deleteChallengeSubmitted = false;
        state.deleting = false;
        state.deleteResource = null;
        state.deleteResourceId = null;
        state.additionalResourceIds = null;
        state.additionalData = null;
        state.postDeleteActions = null;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/DeleteConfirmation/reducer.js